import type React from 'react';
import { useEffect, useRef } from 'react';

interface ImpressionTrackingProps {
  analyticsCallback: () => void;
}

const ImpressionTracking: React.FC<ImpressionTrackingProps> = (props) => {
  const impressionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const { current } = impressionRef;
    if (!current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 1 || entry.isIntersecting) {
          props.analyticsCallback();
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        threshold: 1,
      },
    );

    observer.observe(current);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={impressionRef} />;
};

export default ImpressionTracking;
